import { render } from "./QuestionTemplate.vue?vue&type=template&id=41de7873&scoped=true"
import script from "./QuestionTemplate.vue?vue&type=script&lang=js"
export * from "./QuestionTemplate.vue?vue&type=script&lang=js"

import "./QuestionTemplate.vue?vue&type=style&index=0&id=41de7873&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41de7873"]])

export default __exports__